<template>
  <div class="container-list">
    <div class="flex">
      <unitList v-show="!($store.state.user.userInfo.natureId == 2)" @select="getUnit" @getFirst="getOne"></unitList>
      <div class="flex1">
        <div class="common-page common-head">
          <!-- <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        信息列表
      </div> -->
          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <div class="common-page common-tool-bar">
            <!-- <div class="btn" @click="showDia = true">
          <i class="icon-tr-search"></i>查询
        </div>
        <div class="btn ml10" @click="resetSearch">
          重置
        </div> -->

            <div class="btn ml20" @click="addList()" v-hasPermi="['basic:company:ignoreadd']"><i class="icon-tr-newly-added"></i>新增</div>
          </div>
          <div class="common-page common-list">
            <table class="common-table mt20">
              <thead>
                <tr class="mt10">
                  <th>点位编号</th>
                  <th v-hasPermi="['basic:company:ignoreadd']">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in list" :key="index">
                  <td class="common-add">
                    <el-input v-model="item.number"></el-input>
                  </td>

                  <td class="td-btn">
                    <a class="clear-data" v-hasPermi="['basic:company:ignoreadd']" v-if="!item.company_num">
                      <i class="icon-tr-edit" @click="onSubmit(item, index)"></i>
                    </a>
                    <el-popconfirm
                      title="确定禁用单位记录吗？"
                      class="cursor"
                      @onConfirm="del(item, index)"
                      @confirm="del(item, index)"
                      v-hasPermi="['basic:company:ignoreadd']"
                    >
                      <a slot="reference" class="red">
                        <i class="icon-tr-delete"></i>
                      </a>
                    </el-popconfirm>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <el-pagination
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :total="count"
          ></el-pagination> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import unitList from "@/components/unitList";

export default {
  components: {
    unitList,
  },
  data() {
    return {
      cpNum: "",
      showDia: false,
      searchForm: this.$getForm("qvyusearch"),
      remoteFuncs: {},
      params: { company_num: "", page: 1 },
      list: [],
      count: 0,
      editData: {},
    };
  },
  created() {},
  mounted() {},
  watch: {
    cpNum() {
      this.params.company_num = this.cpNum;
      this.getList();
    },
  },

  methods: {
    getList() {
      this.$post("/crt/stopnumberlist", this.params).then((res) => {
        this.list = res.data;
        this.count = res.data.count;
      });
    },
    del(item, index) {
      if (!item.company_num) {
        this.list.splice(index, 1);
        return;
      }
      this.$post(`/crt/delnumber`, { id: item.id }).then((res) => {
        // this.$message.success("删除成功");
                this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
        this.list.splice(index, 1);
      });
    },
    addList() {
      this.list.push({
        company_num: "",
        number: "",
      });
    },
    onSubmit(item) {
      if (!item.number) {
        this.$message.warning("请输出正确的点位编号");
        return;
      }
      item.company_num = this.cpNum;
      this.$post("/crt/addnumber", item).then((res) => {
        // this.$message.success("操作成功");
                this.$message({
									message: '操作成功',
									type: 'success',
									duration: 700,
								});
        this.getList();
      });
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    // resetSearch() {},
    // searchSubmit() {
    //   this.$refs.searchForm
    //     .getData()
    //     .then((data) => {
    //       //log(data)
    //       this.params = { ...this.params, ...data };
    //       this.params.page = 1;

    //       this.getList();
    //       this.showDia = false;
    //     })
    //     .catch((e) => {});
    // },
    // pageChange(val) {
    //   this.params.page = val;
    //   this.getList();
    // },
  },
};
</script>
<style lang="scss">
.f-list {
  flex-wrap: wrap;

  li {
    width: 240px;
    height: 280px;
    margin-right: 40px;
    margin-bottom: 40px;
  }
}

.com-warp {
  margin-top: 10px;

  li {
    font-size: 18px;
    line-height: 34px;
    color: #333;

    padding-left: 10px;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.f-left {
  width: 260px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-right: 30px;
}
</style>
